<template>
<div class="RollCallTable">
    <div class="handle_select_box">
        <div class="handle_left_box">
            <el-button @click="message" type="primary">消息通知</el-button>
            <el-button @click="exportBtn">导出EXCEL</el-button>
        </div>
        <div class="handle_right_box">
            <div>
                <el-input @focus="closeDetalisInfo" v-model="paramsInfo.joinermobile" placeholder="报名人电话"></el-input>
            </div>
            <div>
                <el-input @focus="closeDetalisInfo" v-model="paramsInfo.ownercustomername" placeholder="报名人姓名"></el-input>
            </div>
            <div>
                <el-input @focus="closeDetalisInfo" v-model="paramsInfo.customername" placeholder="订购人昵称"></el-input>
            </div>
            <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
        </div>
    </div>
    <div class="table_box">
        <el-table @row-click="tableRowClick" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="购票用户头像/昵称" width="240">
                <template slot-scope="scope">
                    <div class="user_info_box">
                        <img :src="scope.row.customericonurl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="ownercustomername" label="报名人姓名" align="center"></el-table-column>
            <el-table-column prop="joinermobile" label="报名人手机" align="center" min-width="160"></el-table-column>
            <el-table-column prop="datetime" label="报名人时间" align="center" min-width="160"></el-table-column>
            <el-table-column prop="ticketname" label="票种" align="center" min-width="160"></el-table-column>
            <el-table-column label="价格(元)" align="center">
                <template slot-scope="scope"><span style="color: #FF4747;">{{scope.row.uprice}}</span></template>
            </el-table-column>
            <el-table-column label="状态" align="center" show-overflow-tooltip>
                <template slot-scope="scope"><span :class="orderStatusClass(scope.row.statustext)">{{scope.row.statustext}}</span></template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="searchBtn"></page>
    </div>
    <div class="msg_pop_box">
        <el-dialog title="发送消息" :visible.sync="showMsgPop">
            <div class="tips_content_box">
                <!-- <img :src="require('@/common/images/activeOperate/tips.png')" alt=""> -->
                <p class="padding_bottom8">发送方式</p>
                <p class="padding_bottom8"><span style="color: #333333;">短信通知</span>&emsp;&emsp;<span>可用余额：￥{{eventInfoData.allbalance}}</span>&emsp;&emsp;<label @click="recharge" style="color: #409EFF; cursor: pointer;">去充值></label></p>
                <p class="padding_bottom12">发送范围</p>
                <div class="msg_select_box">
                    <el-select v-model="userType" placeholder="全部用户">
                        <el-option v-for="item in userOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <p class="padding_bottom12 padding_top12">发送内容</p>
                <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6}" placeholder="请输入通知内容" v-model="msgText"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showMsgPop = false">取 消</el-button>
                <el-button type="primary" @click="sureBtn()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
    <div class="right_details_box bgc box-shadow" :class="showHelp ? 'show_helps_box' : 'hide_icon_box'" ref="helps">
        <div v-if="showHelp" class="show_helps show_icon" @click="showHelp = false"></div>
        <div class="title_box">
            <span>报名资料</span>
            <img @click="showHelp = false" :src="require('@/common/images/activeOperate/close_icon.png')" alt="">
        </div>
        <div class="details_info_box">
            <div class="box1">
                <img :src="listDetailsInfo.customericonurl" alt="">
                <div>
                    <p>{{listDetailsInfo.customername}}</p>
                    <p>票种：{{listDetailsInfo.ticketname}}</p>
                    <!-- <p>票种张数：{{listDetailsInfo.ticketcount}}</p> -->
                    <p>票种张数：1</p>
                </div>
            </div>
            <div class="box2">
                <p>详细信息</p>
                <p v-if="listDetailsStatus === 30"><span>票号</span><span>{{listDetailsInfo.ticketno}}</span></p>
                <p><span>姓名</span><span>{{listDetailsInfo.joinername}}</span></p>
                <p><span>手机</span><span>{{listDetailsInfo.joinermobile}}</span></p>
                <p v-for="(item, index) in listDetailsInfo.objlist" :key="index"><span>{{item.name}}</span><span>{{item.value}}</span></p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getEenrolleventUserList, exportEventUserList, getEventUserInfoDetail, sendMessageNotice} from 'api/activeApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'RollCallTable',
    props: ['eventListData', 'activeStatus', 'eventInfoData'],
    data() {
        return {
            showMsgPop: false, // 消息通知弹窗是否显示
            msgText: '', // 消息通知弹窗消息内容
            userOptions: [ // 消息通知范围
                {
                    value: 1,
                    label: '全部用户'
                },
                {
                    value: 2,
                    label: '已报名成功用户'
                },
                {
                    value: 3,
                    label: '本页选中用户'
                }
            ],
            userType: 1,
            total: 0, // 页码
            tableData: [], // 名单表格数据
            multipleSelection: [], // 选中名单表格行的数据
            paramsInfo: {
                joinermobile: '', // 报名人电话
                ownercustomername: '', // 报名人姓名
                customername: '' // 订购人昵称
            },
            showHelp: false, // 右侧名单详情显示隐藏
            oldOrderinnerid: '',
            oldJoinerid: '',
            newOrderinnerid: '',
            newJoinerid: '',
            listDetailsStatus: '',
            listDetailsInfo: {
                customericonurl: '',
                customername: '',
                joinermobile: '',
                joinername: '',
                objlist: [],
                ticketcount: '',
                ticketname: '',
                ticketno: ''
            }
        }
    },
    mounted() {},
    methods: {
        // 消息通知弹窗
        message() {
            // console.log(this.multipleSelection)
            this.msgText = ''
            this.showMsgPop = true
        },
        // 消息通知弹窗确认按钮
        sureBtn() {
            if (this.userType === 3) {
                if (this.multipleSelection.length === 0) {
                    this.$message.error(`您当前没有选用户，请选择需要发送的用户`)
                    this.showMsgPop = false
                    return
                }
            }
            if (this.msgText === '') {
                this.$message.error(`发送消息不能为空！`)
                return
            }
            var sendMsgList = []
            for (let i = 0; i < this.multipleSelection.length; i++) {
                sendMsgList.push(this.multipleSelection[i].joinid)
            }
            sendMsgList = sendMsgList.join(',')
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                status: this.userType,
                joinid: sendMsgList,
                smsContent: this.msgText
            }
            // console.log(params)
            sendMessageNotice({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.showMsgPop = false
                    this.$message.success(`短信通知提交成功！`)
                    this.$emit('findSimpleEventDetail')
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 去充值
        recharge() {
            let newurl = this.$router.resolve({
                name: 'Balance'
            })
            window.open(newurl.href, '_blank')
        },
        closeDetalisInfo() {
            this.showHelp = false
        },
        tableRowClick(row, event, column) {
            // console.log(row)
            this.oldOrderinnerid = this.newOrderinnerid
            this.oldJoinerid = this.newJoinerid
            this.newOrderinnerid = row.orderno
            this.newJoinerid = row.joinerid
            if ((this.oldOrderinnerid === this.newOrderinnerid) && (this.oldJoinerid === this.newJoinerid)) {
                this.showHelp = !this.showHelp
            } else {
                this.listDetailsStatus = row.status
                this.showHelp = false
                this.findEventUserInfoDetail(row)
            }
        },
        // 查询名单详情
        findEventUserInfoDetail(val) {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                orderno: val.orderno,
                joinid: val.joinerid
            }
            getEventUserInfoDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.listDetailsInfo = data.data
                    this.showHelp = true
                    // setTimeout(() => {
                    //     this.showHelp = true
                    // },50 )
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 分页及搜索
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchBtn() {
            // this.$message.success(`第${this.page.page}页`)
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                eventstatus: this.activeStatus
            }
            getEenrolleventUserList({
                data: Object.assign({}, params, this.paramsInfo, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.closeDetalisInfo()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        // 导出按钮
        exportBtn() {
            this.closeDetalisInfo()
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                eventstatus: this.activeStatus
            }
            exportEventUserList({
                data: Object.assign({}, params, this.paramsInfo),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '名单管理' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        orderStatusClass(val) {
            if (val === '待审核' || val === '待支付') {
                return 'yellow_text'
            } else if (val === '报名成功') {
                return 'green_text'
            } else if (val === '已拒绝' || val === '已取消') {
                return 'gray_text'
            } else if (val === '审核拒绝') {
                return 'red_text'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        eventListData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                // console.log('this.eventListData:', this.eventListData)
                this.showHelp = false
                this.tableData = this.eventListData.content
                this.total = 0
                this.paramsInfo.joinermobile = ''
                this.paramsInfo.ownercustomername = ''
                this.paramsInfo.customername = ''
                setTimeout(() => {
                    this.total = this.eventListData.pageinfo.rowCount
                }, 20)
            })
        }
    },
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
.RollCallTable {
    padding: 0 20px;
    .handle_select_box {
        display: flex;
        justify-content: space-between;
        .handle_left_box {
            .el-button+.el-button {
                margin-left: 30px;
            }
        }
        .handle_right_box {
            display: flex;
            &>div {
                width: 150px;
                margin-right: 30px;
            }
        }
    }
    .table_box {
        background-color: #fff;
        margin-top: 30px;
        padding-bottom: 20px;
        .el-table th>.cell {
            font-weight: bold!important;
        }
        .el-table__empty-block {
            min-height: 360px;
        }
        .el-table__empty-text {
            box-sizing: border-box;
            line-height: 0px;
            padding-top: 150px;
        }
        .el-table__row {
            cursor: pointer;
        }
        .user_info_box {
            display: flex;
            align-items: center;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
            span {
                color: #409EFF;
            }
        }
        .green_text {
            color: #0ABF53;
        }
        .yellow_text {
            color: #FFA904;
        }
        .gray_text {
            color: #909399;
        }
        .red_text {
            color: #FF4747;
        }
    }
    .msg_pop_box {
        .el-dialog {
            width: 580px;
        }
        .el-dialog__footer {
            padding: 10px 0;
        }
        .tips_content_box {
            padding: 10px 32px;
            .el-input__icon {
                line-height: 1px;
            }
            p {
                line-height: 20px;
                color: #666666;
            }
            .msg_select_box {
                .el-input__inner {
                    width: 476px;
                }
            }
            .padding_bottom8 {
                padding-bottom: 8px;
            }
            .padding_bottom12 {
                padding-bottom: 12px;
            }
            .padding_top12 {
                padding-top: 12px;
            }
        }
    }
    .right_details_box{
        overflow: scroll;
        position: fixed;
        top: 50px;
        right: -398px;
        height: 95.5vh;
        width: 398px;
        z-index: 10;
        box-sizing: border-box;
        box-shadow:-2px 0px 6px 0px rgba(0,0,0,0.1);
        font-family:PingFangSC-Regular,PingFang SC;
        .show_helps{
            width: 12px;
            height: 50px;
            background-size:12px 50px !important;
            position: absolute;
            top: 46%;
            left: -12px;
            cursor: pointer;
            border-radius: 6px 0 0 6px;
        }
        .show_helps:hover{
            background-color: #ccc;
        }
        .show_icon{
            background-image: url('../../../common/images/other/show.png');
        }
        .title_box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            height: 52px;
            box-shadow: -2px 0px 6px 0px rgba(0,0,0,0.1);
            span{
                font-weight: bold;
                font-size: 15px;
            }
            img {
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
        .details_info_box {
            .box1 {
                display: flex;
                align-items: center;
                padding: 30px 20px 40px 20px;
                img {
                    width: 64px;
                    height: 64px;
                    border-radius: 100%;
                    margin-right: 28px;
                }
                div {
                    p{
                        color:#999999;
                        line-height:20px;
                    }
                    p:nth-of-type(1){
                        color: #333333;
                    }
                    p:nth-of-type(2){
                        margin-top: 8px;
                        margin-bottom: 4px;
                    }
                }
            }
            .box2 {
                padding: 0 20px 30px;
                p{
                    display: flex;
                    line-height:20px;
                    color: #333333;
                    margin-top: 20px;
                    span:nth-of-type(1){
                        line-height:20px;
                        color:#999999;
                        // margin-right: 80px;
                        width: 120px;
                        min-width: 120px;
                        white-space: nowrap;
                    }
                    span:nth-of-type(2){
                        line-height:20px;
                    }
                }
                p:nth-of-type(1){
                    margin-top: 0px;
                    border-bottom: solid 1px #E5E5E5;
                    padding: 8px 0;
                    font-weight: bold;
                    font-size: 15px;
                }
            }
        }
    }
    .show_helps_box{
        right: 0;
        transition: 0.5s all;
    }
    .hide_icon_box{
        right: -398px;
        transition: 0.5s all;
    }
}
</style>